import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class PedidoAtividadeService {
    dadosCompartilhados: any = {};

    setDados(dados: any) {
        this.dadosCompartilhados = dados;
    }

    getDados() {
        return this.dadosCompartilhados;
    }
}

